import { createStyles, withStyles } from '@mui/styles';
import React from 'react';

import horizontalButterLogo from '../../images/logos/horizontal_butter_logo.png';
import LogoComponent from './LogoComponent';

const styles = () =>
  createStyles({
    logo: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  });

function HorizontalButterLogo(props: any) {
  return <LogoComponent {...props} logoSrc={horizontalButterLogo} />;
}

export default withStyles(styles)(HorizontalButterLogo);
